<template>
	<page>
        <module title="成长任务配置">
            <c-form ref="form">
				<c-form title="任务列表">
					<c-form-item>
						<c-table v-model="growthTaskData" border height="550">
							<c-table-column
							    label="任务图标"
								name="task_icon"
							    width="70">
							    <template v-slot="row">
									<c-image v-if="row.data.task_icon" :src="row.data.task_icon" preview size="30" ></c-image>
									<span v-else>-</span>
							    </template>
							</c-table-column>
							
						    <c-table-column
						        label="任务类型"
						        width="90"
						    >
						        <template v-slot="row">
									{{taskTypeMap[row.data.task_type]}}
						        </template>
						    </c-table-column>

                            <c-table-column
                                    label="是否启用"
                                    width="80"
                            >
                                <template v-slot="{data}">
                                    <span v-if="data.state == 2" style="color:green">启用</span>
                                    <span v-else style="color:red">停用</span>
                                </template>
                            </c-table-column>
							
							<c-table-column
							    label="任务描述"
								name="task_desc"
							    width="300">
							    <template v-slot="row">
									{{row.data.task_desc||'-'}}
							    </template>
							</c-table-column>
							
						    <c-table-column
						        label="获得成长值"
								name="award_value"
						        width="200"
						    >
								<template v-slot="row">
									<span v-if="row.data.task_type == 3">
										每{{row.data.sign_in_calendar_growth_period}}天作为一个签到周期，周期内每天完成签到，则在完成该周期后，可获得额外奖励：
										<span v-if="row.data.sign_in_continuity_reward_growth>0" style="color: blue">{{row.data.sign_in_continuity_reward_growth}}成长值</span>
										<span v-if="row.data.sign_in_continuity_reward_points>0" style="color: blue">
                                            <span v-if="row.data.sign_in_continuity_reward_growth>0">；</span>
                                            {{row.data.sign_in_continuity_reward_points}}积分
                                        </span>
									</span>
									<span v-else-if="row.data.task_type == 4">
										每次分享获得获得<span style="color: blue">{{row.data.award_value}}</span>成长值
										<span v-if="row.data.product_name" style="color:darkgray">，点击分享跳转至商品【{{row.data.product_name}}】详情页</span>
									</span>
									<span v-else-if="row.data.task_type == 5">
										每消费{{row.data.order_growth_money_unit}}元
										<span>，获得{{row.data.award_value}}成长值</span>
									</span>
									<span v-else>{{row.data.award_value}}</span>
								</template>
						    </c-table-column>
							
						    <c-table-column
						        label="日/次上限"
								name="day_max_count"
						        width="90"
						    >
								<template v-slot="row">
									<span v-if="row.data.task_type == 1 || row.data.task_type == 2 || row.data.task_type == 3">单次</span>
									<span v-else-if="row.data.task_type == 5">不限</span>
									<span v-else>{{row.data.day_max_count}}</span>
								</template>
						    </c-table-column>
							
						    <c-table-column
						        label="月/次上限"
								name="month_max_count"
						        width="90"
						    >
								<template v-slot="row">
									<span v-if="row.data.task_type == 1 || row.data.task_type == 2 || row.data.task_type == 3">-</span>
									<span v-else-if="row.data.task_type == 5">不限</span>
									<span v-else>{{row.data.month_max_count}}</span>
								</template>
						    </c-table-column>
							
							<c-table-column
							    type="button"
							    fixed="right"
							    label="操作"
							    width="110"
							>
							  <template v-slot="row">
									<c-table-button @click="editTaskConfig(row)">编辑</c-table-button>
                                    <c-table-button v-if="row.data.state == 2" @click="startHandle('1', row.data)">停用</c-table-button>
                                    <c-table-button v-else-if="row.data.state == 1" @click="startHandle('2', row.data)">启用</c-table-button>
							  </template>
							</c-table-column>
						</c-table>
					</c-form-item>
				</c-form>
            </c-form>
        </module>
		
		<c-dialog ref="taskEditDialog" :title="'『'+taskTypeMap[editData.task_type]+'』任务编辑'" width="700" height="500" @resolve="editTaskHandle">
			<c-form ref="taskEditForm">
				<c-form-item type="hidden" name="id"></c-form-item>
				<c-form-item type="hidden" name="task_type"></c-form-item>
				<c-form-item type="image" label="任务图标" size="10" name="task_icon" file-word="建议尺寸：100×100像素的透明图片"></c-form-item>
				<c-form-item type="number" label="获得成长值" v-show="editData.task_type!=3" name="award_value" v-model="award_value" :limit="[0,9999]" decimal="0"></c-form-item>
				<c-form-item type="number" label="日/次上限" v-show="editData.task_type!=1 && editData.task_type!=2 && editData.task_type!=3 && editData.task_type!=5"
                             name="day_max_count" :limit="[0,9999]" decimal="0"></c-form-item>
				<c-form-item type="number" label="月/次上限" v-show="editData.task_type!=1 && editData.task_type!=2 && editData.task_type!=3 && editData.task_type!=5"
                             name="month_max_count" :limit="[0,9999]" decimal="0"></c-form-item>
                <c-form-item label="关联商品" v-show="editData.task_type == 4||editData.task_type == 5">
                    <c-button v-if="!productInfo" style="margin: 5px 0;" @click="$refs.productSelector.open()">选择商品</c-button>
                    <c-button v-if="productInfo" color="red" style="margin: 5px 0;" @click="removePrduct()">删除商品</c-button>
                    <div v-if="productInfo" class="flex">
                        <c-image :src="productInfo.product_img_url" size="100"></c-image>
                        <p style="width: 350px; margin-top: 10px; margin-left: 18px; line-height: 20px; font-size: 13px; color: #444;">{{productInfo.product_name}}</p>
                        <span slot="word" style="color:darkgray">
                            选择商品后，小程序上点击“去完成”则跳转该商品详情
                        </span>
                    </div>
                </c-form-item>
                <c-form-item type="number" decimal="0" label="签到周期" v-show="editData.task_type==3" name="sign_in_calendar_growth_period" input-unit="天" readonly disabled required word="可设置连续签到X天作为一个周期，即连续签到X天即可获得外成长值">
					<span slot="word"><a class="s-link" @click="signInCalendarConfig()">&nbsp;签到周期配置&nbsp;</a></span>
				</c-form-item>
                <c-form-item type="number" decimal="0" label="评论字数下限" v-show="editData.task_type==9" v-model="commentWordsLimit" name="comment_words_limit" :limit="[5,999]" word="发表的评论字数必须达标，且且不能包含违禁词，才能给予奖励"></c-form-item>
                <c-form-item type="number" decimal="0" label="额外积分奖励" v-show="editData.task_type==7 || editData.task_type==8" v-model="extarPoints"  name="extar_points" :limit="[0,999]" word="优质帖单独奖励5积分（是否优质帖需后台人工审核判断）"></c-form-item>
                <c-form-item type="number" decimal="0" label="额外积分奖励" v-show="editData.task_type==3" name="sign_in_continuity_reward_points" :limit="[0,999]" word="每个签到周期的最后一天签到，可获得额外的积分奖励"></c-form-item>
				<c-form-item type="number" decimal="2" v-show="editData.task_type==5" label="订单消费金额" name="order_growth_money_unit" v-model="order_growth_money_unit"
                             :limit="[0.01,9999]"  input-unit="元" required :word="orderGrowthMoneyUnitWord"></c-form-item>
				<c-form-item type="textarea" label="任务描述" name="task_desc"></c-form-item>
			</c-form>
		</c-dialog>
		
		
        <!--配置签到周期弹窗-->
        <c-dialog ref="signInCalendarDialog" title="签到周期配置" width="500"  @resolve="submitSignInAwardConfig">
            <m-operate>
                <c-button color="gray" hollow @click="addSignInCalendarRow()">添加一行</c-button>
            </m-operate>
            <c-table v-model="signInCalendarData"  height="400">
				<c-table-column
					label="签到天数"
					width="90"
				>
					<template v-slot="{data, index}">
						{{`第${index + 1}天`}}
					</template>
				</c-table-column>

				<c-table-column
					label="获得成长值"
					width="120">
					<template v-slot="row">
						<c-input v-model="row.data.award_growth" type="number" decimal="0"  :limit="[1,99999]" ></c-input>
					</template>
				</c-table-column>

				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="70">
					<template v-slot="row">
						<c-table-button @click="row.remove()">删除</c-table-button>
					</template>
				</c-table-column>
            </c-table>
        </c-dialog>

        <product-selector ref="productSelector" @resolve="productSelectHandle"></product-selector>
    </page>
</template>

<script>
	import productSelector from "@/components/service/product_selector.vue";

    export default {
		name: 'm_points_regulation',
        data() {
              return {
                signInCalendarData:[],
				growthTaskData: [],
				editData: {},
				taskTypeOptions: [
                    {name: '注册',value: 1},
                    {name: '完善资料',value: 2},
                    {name: '签到',value: 3},
                    {name: '分享',value: 4},
                    {name: '订单消费',value: 5},
                    {name: '订单评价',value: 6},
                    {name: '社区发帖(分享)',value: 7},
                    {name: '社区发帖(话题)',value: 8},
                    {name: '社区评论',value: 9}
				],
				taskTypeMap: {},
                award_value:0,
                order_growth_money_unit:0,
                productId:0,
                productInfo:undefined,
                extarPoints:0,
                commentWordsLimit:0,
              }
        },
        computed: {
            orderGrowthMoneyUnitWord() {
                var tipWord= '确认收货时，订单实际消费每达到【'+this.order_growth_money_unit+'】元,即可获得【'+this.award_value+'】成长值;';
                tipWord = tipWord + '获得成长值将向下取整,即计算得出应赠送【5.9】成长值，最终获得成长值为【5】';
                return tipWord;
            },
        },
        components: {
            productSelector

        },
        mounted() {
			this.getTaskList();
			
			// 使用reduce方法将数组转换为以value为键，name为值的对象
			this.taskTypeMap = this.taskTypeOptions.reduce((map, item) => {
				map[item.value] = item.name;
				return map;
			}, {});
        },

        methods: {
			//查询成长任务列表
			getTaskList(){
			    //加载签到周期配置
			    this.request({
			      url: '/growth_config/task/list',
			      success: data => {
			          this.growthTaskData = data;
			      }
			    });
			},
            //选择商品（回调）
            productSelectHandle(data) {
                this.productId = data[0].product_id;
                this.productInfo = {
                    product_name: data[0].product_name,
                    product_img_url: data[0].product_img_url
                }
            },

            //删除商品
            removePrduct(){
                this.$refs.form.set({
                    product_id: 0
                });
                this.productInfo = undefined;
            },

			//编辑成长任务（弹框）
			editTaskConfig(row){
                this.productId = 0;
                this.productInfo = undefined;
				this.editData = row.data;
				this.signInCalendarData = [];
				//签到加载签到周期明细
				if(this.editData.task_type == 3){
					//加载签到周期配置
					this.request({
						url: '/growth_config/signin/list',
						success: data => {
							this.signInCalendarData = data;
						}
					});
				}else if(this.editData.task_type == 4 || this.editData.task_type == 5){
                    if (this.editData.product_id && this.editData.product_name){
                      this.productId = this.editData.product_id;
                      this.productInfo = {
                        product_name: this.editData.product_name,
                        product_img_url: this.editData.product_img_url
                      }
                    }
                }else if((this.editData.task_type == 7 || this.editData.task_type == 8)&&this.editData.extra_json){
                    let jsonObj = JSON.parse(this.editData.extra_json);
                    this.extarPoints = parseInt(jsonObj.extar_points||0);
                }else if(this.editData.task_type == 9 && this.editData.extra_json){
                    let jsonObj = JSON.parse(this.editData.extra_json);
                    this.commentWordsLimit = parseInt(jsonObj.comment_words_limit||0);
                }
                if (row.data && row.data.order_growth_money_unit){
                    this.order_growth_money_unit = row.data.order_growth_money_unit||0;
                }
				this.$refs.taskEditForm.clear();
				this.$refs.taskEditForm.set(row.data);

				this.$refs.taskEditDialog.open();
			},
			//编辑成长任务（提交）
			editTaskHandle(){
				let data = this.$refs.taskEditForm.get();
				
				//签到周期数据
				if(data.task_type == 3){
					data.signin_config_list= this.signInCalendarData
				}else if ((data.task_type == 4||data.task_type == 5) && this.productId != 0){//分享商品、消费
                    var extra_json = {};
                    extra_json.product_id = this.productId;
                    data.extra_json = JSON.stringify(extra_json);
                }else if ((data.task_type == 7||data.task_type == 8) && this.extarPoints != 0){//分享商品、消费
                    var extra_json = {};
                    extra_json.extar_points = this.extarPoints;
                    data.extra_json = JSON.stringify(extra_json);
                }else if ((data.task_type == 9) && this.commentWordsLimit != 0){//分享商品、消费
                    var extra_json = {};
                    extra_json.comment_words_limit = this.commentWordsLimit;
                    data.extra_json = JSON.stringify(extra_json);
                }
				this.request({
					url: '/growth_config/task/edit',
					data: data,
					loading: true,
					success: data => {
						this.$message({
							text: '保存成功',
							icon: 'success'
						});
						this.getTaskList();
					}
				});
			},
            //启停用
            startHandle(type, data) {
                this.$confirm({
                    text: `确定要${type == '1' ? '停用' : '启用'}成长值任务【`+this.taskTypeMap[data.task_type]+`】？`,
                    resolve: () => {
                        this.request({
                            url: '/growth_config/task/state/edit',
                            data: {
                                state: type,
                                id: data.id
                            },
                            loading: true,
                            success: () => {
                                //刷新列表
                                this.getTaskList();
                            }
                        });
                    }
                });
            },
            /**
             * 签到周期，添加行
             * @returns {boolean}
             */
            addSignInCalendarRow(){
				if (this.signInCalendarData.length >= 30){
					this.$message({
						text: '最多添加30行记录',
						icon: 'fail'
					});
					return false;
				}
				this.signInCalendarData.push({
					"award_growth":1
				});
            },
			
			//查询签到周期配置（弹框）
			signInCalendarConfig(){
				//弹框
				this.$refs.signInCalendarDialog.open();
			},
            /**
             * 提交签到周期配置
             */
            submitSignInAwardConfig(stop){
                stop();
                if (!this.signInCalendarData || this.signInCalendarData.length == 0){
					this.$message({
						text: '请至少添加一条记录',
						icon: 'fail'
					});
					return false;
                }
                for (let i in this.signInCalendarData) {
					let obj = this.signInCalendarData[i];
					if (!obj.award_growth ||isNaN(obj.award_growth)) {
						this.$message({
							text: '请输入获得的成长值',
							icon: 'fail'
						});
						return false;
					}
                }
				//设置签到周期
				this.$refs.taskEditForm.set({sign_in_calendar_growth_period: this.signInCalendarData.length});
				
				this.$refs.signInCalendarDialog.close();
            },
        }
	}
</script>